import {
    Input,
    Component,
    Output,
    EventEmitter,
    Inject
} from '@angular/core';

import { TOAST_DATA } from '../toastr.service';

@Component({
    selector: 'app-toast-success-to-steam',
    templateUrl: './toast-success-to-steam.component.pug',
    styleUrls: ['./toast-success-to-steam.component.less'],
})
export class ToastSuccessToSteamComponent {
    @Input() count: number = null;

    constructor(
        @Inject(TOAST_DATA) public data: any
    ) {
    }
}
